import { render, staticRenderFns } from "./Risks.vue?vue&type=template&id=2920abc9&scoped=true"
import script from "./Risks.vue?vue&type=script&lang=js"
export * from "./Risks.vue?vue&type=script&lang=js"
import style0 from "./Risks.vue?vue&type=style&index=0&id=2920abc9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2920abc9",
  null
  
)

export default component.exports